import { DimensionAttribute } from './dimension-attribute';

export class Dimension {
    id?: string;
    caption?: string;
    tablename?: string;
    dimensionAttributes: DimensionAttribute[] = [];
    label = ''; // dieses Attribut wir nur wegen der his-multiselect Komponente benötigt, das multiselect sollte von SYS irgendwann mal refactored werden
    factTableId?: string;
    description?: string;
    defaultRelease?: string;
    joinableDimensionsExist: boolean = false;
    rolePlayingDimensions: Dimension[] = [];
    secondaryFactsLabel: string = '';
    hidden?: boolean;

    // used for testing purposes
    static getMockDim(attrs: DimensionAttribute[]) {
        let dim = new Dimension();
        dim.dimensionAttributes = attrs;
        return dim;
    }

}
